<template>
  <ul class="el-select-dropdown__list">
    <slot></slot>
  </ul>
</template>

<script>
export default {}
</script>

<style lang="css" scoped>
.el-select-dropdown__list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow: auto;
}
</style>
